
import {parseISO, format, parse} from 'date-fns';
import { dispatchData } from './dispatchData';
import axios from 'axios';

export const formatDateDB = (value) => {
  if (!value) return '-';
  try {
    const date = parseISO(value); 
    return format(date, 'dd/MM/yyyy'); 
  } catch (error) {
    console.error('Data inválida:', value);
    return '-';
  }
};
export const formatDatePT = (value) => {
  if (!value) return '-';
  try {    
    return format(value, 'dd/MM/yyyy'); // Retorna no formato desejado
  } catch (error) {
    console.error('Data inválida:', value);
    return '-';
  }
};
export const formatDateToDB = (dateStr) => {
  try {
    const parsed = parse(dateStr, 'dd/MM/yyyy', new Date());
    return format(parsed, 'yyyy-MM-dd');
  } catch (err) {
    console.error('Erro ao converter data:', dateStr);
    return null;
  }
};

export const FlashMessageHeader = (messageHeader, colorBackHeader, callback) => {
 
  sendMessageFN(messageHeader, colorBackHeader);
  setTimeout(() => {
    closeMessageFN();
  }, 2500);
  if (callback) {
    setTimeout(() => {
      if (typeof callback === 'function') {
        callback(); // Executa a função passada como argumento
      } else {
        console.error('Callback não é uma função válida');
      }
    }, 2800);
  }
};
const sendMessageFN = (messageHeader, typeNotification) => {
  
  const data = {
    activeMessageHeader: true,
    typeNotification,
    messageHeader,
  };
  dispatchData('MESSAGE_HEADER_OPEN', data);
};
const closeMessageFN = () => {
  const data = {
    activeMessageHeader: false,
    typeNotification: '',
    messageHeader: '',
  };
  dispatchData('MESSAGE_HEADER_CLOSE', data);
};
function normalizeString(str) {
  return str
    .normalize("NFD") // Decompõe acentos
    .replace(/[\u0300-\u036f]/g, "") // Remove marcas diacríticas
    .replace(/[^\w\s]/gi, "") // Remove caracteres especiais
    .toLowerCase()
    .trim();
}

export const filterFn = (images, query) => {
  const normalizedQuery = normalizeString(query);

  return images.filter((img) => {
    const normalizedName = normalizeString(img.name);
    return normalizedQuery
      .split(" ")
      .every((word) => normalizedName.includes(word));
  });
};
export const postServer = async (url, data = {}) => {
 
  const resp = await axios.post(`${process.env.URL_SITE}${url}`, data, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true, // garante que os cookies sejam apagados no logout
  }); 

  return resp.data;
};